import { render, staticRenderFns } from "./OrderViewActionClaim.vue?vue&type=template&id=5e76fef1&scoped=true&"
import script from "./OrderViewActionClaim.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionClaim.vue?vue&type=script&lang=js&"
import style0 from "./OrderViewActionClaim.vue?vue&type=style&index=0&id=5e76fef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e76fef1",
  null
  
)

export default component.exports